<template>
  <div class="flex justify-center items-center flex-col" style="height: 100%">
    <div class="container">
      <div class="cat is-dancing" aria-label="dancing cat">
        <div class="cat__shadow"></div>
        <div class="cat__paw cat__paw--back-l"></div>
        <div class="cat__paw cat__paw--back-r"></div>
        <div class="cat__body">
          <div class="cat__tail"></div>
          <div class="cat__body_overlay"></div>
        </div>
        <div class="cat__head">
          <div class="cat__ear cat__ear--l"></div>
          <div class="cat__ear cat__ear--r"></div>
          <div class="cat__face">
            <span class="cat__eye cat__eye--l"></span>
            <span class="cat__eye cat__eye--r"></span>
            <span class="cat__mouth"></span>
            <div class="cat__nose"></div>
          </div>
        </div>

        <div class="cat__paw cat__paw--l"></div>
        <div class="cat__paw cat__paw--r"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* base look — reuse your existing colors/shapes */
.cat {
  position: relative;
  width: 260px;
  height: 210px;
  margin: 2rem auto;
}
.cat__shadow {
  position: absolute;
  inset: auto 10% 0;
  height: 10px;
  background-color: rgb(193 193 193 / 50%);
  filter: blur(1px);
  border-radius: 10px;
}

/* simple circles/rounded rects just for demo: */
.cat__body,
.cat__head,
.cat__paw,
.cat__tail,
.cat__ear {
  background: #2d8a89;
  border-radius: 999px;
}
.cat__body {
  position: absolute;
  width: 170px;
  height: 130px;
  left: 45px;
  bottom: 45px;
}
.cat__body_overlay {
  position: absolute;
  width: 170px;
  height: 130px;
  left: 0;
  bottom: 0;
  background: #2d8a89;
  border-radius: 999px;
}
.cat__head {
  position: absolute;
  width: 120px;
  height: 100px;
  left: 110px;
  top: 20px;
  background: #2f9896;
}
.cat__paw {
  position: absolute;
  width: 36px;
  height: 22px;
  bottom: 22px;
  background: #e9f5f5;
}
.cat__paw--l {
  left: 90px;
}
.cat__paw--r {
  left: 150px;
}
.cat__tail {
  position: absolute;
  width: 110px;
  height: 22px;
  right: 110px;
  top: 60px;
  transform-origin: 10% 50%;
  background: #006f75;
}
.cat__ear {
  position: absolute;
  width: 26px;
  height: 36px;
  top: -10px;
  background: #215e5d;
}
.cat__ear--l {
  left: 18px;
  transform: skewX(-8deg);
}
.cat__ear--r {
  right: 18px;
  transform: skewX(8deg);
}
.cat__nose {
  background-color: #ffffff;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  position: absolute;
  top: 52px;
  left: 48px;
  box-shadow: 12px 0 #ffffff;
}

/* face bits */
.cat__face {
  position: absolute;
  inset: 0;
}
.cat__eye {
  position: absolute;
  top: 42px;
  width: 18px;
  height: 6px;
  left: 30px;
  border-radius: 6px;
  background: #0f1823;
}
.cat__eye--r {
  left: auto;
  right: 30px;
}
.cat__mouth {
  position: absolute;
  left: 50%;
  top: 58px;
  width: 18px;
  height: 16px;
  background: #141a20;
  transform: translateX(-50%);
  border-radius: 0 0 10px 10px;
}

/* ---- animations: apply only while dancing ---- */
.cat.is-dancing {
  /* subtle overall bounce */
  animation: bounce var(--beat) var(--ease) infinite;
}
.cat.is-dancing .cat__body {
  /* hip sway */
  animation: sway calc(var(--beat) * 2) var(--ease) infinite;
}
.cat.is-dancing .cat__head {
  /* head nod + tiny tilt */
  transform-origin: 50% 85%;
  animation:
    nod var(--beat) var(--ease) infinite,
    tilt calc(var(--beat) * 4) ease-in-out infinite;
}

.cat.is-dancing .cat__tail {
  transform-origin: 90% 50%;
  animation: wag calc(var(--beat) * 4) ease-in-out infinite;
}
.cat.is-dancing .cat__ear {
  transform-origin: 50% 100%;
  animation: earFlick calc(var(--beat) * 8) steps(1, end) infinite;
}
.cat.is-dancing .cat__paw--l {
  transform-origin: 50% 50%;
  animation: stepL var(--beat) var(--ease) infinite;
}
.cat.is-dancing .cat__paw--r {
  transform-origin: 50% 50%;
  animation: stepR var(--beat) var(--ease) infinite;
}
.cat.is-dancing .cat__eye {
  /* blink occasionally */
  animation: blink calc(var(--beat) * 12) steps(1, end) infinite;
}

.cat__paw--back-l,
.cat__paw--back-r {
  background: #358b89;
  opacity: 0.8;
  z-index: 0;
  position: absolute;
  width: 38px;
  height: 30px;
  border-radius: 999px;
  bottom: 37px;
}

.cat__paw--back-l {
  left: 65px;
}
.cat__paw--back-r {
  left: 160px;
}

/* Optional small idle wiggle */
.cat.is-dancing .cat__paw--back-l,
.cat.is-dancing .cat__paw--back-r {
  animation: backStep 1.6s var(--ease) infinite alternate;
}

/* ---- keyframes ---- */
@keyframes backStep {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(10px);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}
@keyframes sway {
  0%,
  100% {
    transform: translateX(-6px) scaleX(1.02);
  }
  50% {
    transform: translateX(6px) scaleX(0.98);
  }
}
@keyframes nod {
  0%,
  100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-6deg);
  }
}
@keyframes tilt {
  0%,
  100% {
    rotate: 2deg;
  }
  50% {
    rotate: -2deg;
  }
}
@keyframes wag1 {
  0%,
  100% {
    rotate: 18deg;
  }
  50% {
    rotate: -18deg;
  }
}
@keyframes wag {
  0% {
    transform: rotate(15deg) translateX(2px);
  }
  13% {
    transform: rotate(5deg) translateX(-1px);
  }
  25% {
    transform: rotate(-15deg) translateX(-3px);
  }
  38% {
    transform: rotate(-5deg) translateX(1px);
  }
  50% {
    transform: rotate(15deg) translateX(2px);
  }
  63% {
    transform: rotate(10deg) translateX(2px);
  }
  85% {
    transform: rotate(35deg) translateX(-3px);
  }
  100% {
    transform: rotate(15deg) translateX(2px);
  }
}
@keyframes earFlick {
  0%,
  97% {
    transform: skewX(0deg);
  }
  98%,
  99% {
    transform: skewX(-10deg);
  }
  100% {
    transform: skewX(0deg);
  }
}
@keyframes stepL {
  0%,
  100% {
    transform: translateY(0) scaleY(1);
  }
  50% {
    transform: translateY(-6px) scaleY(0.9);
  }
}
@keyframes stepR {
  0%,
  100% {
    transform: translateY(-6px) scaleY(0.9);
  }
  50% {
    transform: translateY(0) scaleY(1);
  }
}
@keyframes blink {
  0%,
  97%,
  100% {
    height: 6px;
  }
  98%,
  99% {
    height: 1px;
  }
}

/* respect reduced-motion */
@media (prefers-reduced-motion: reduce) {
  * {
    animation: none !important;
  }
}
</style>
